export const CRUD_GET_LIST = 'EPIC/CRUD_GET_LIST';
export const CRUD_GET_LIST_FAILURE = 'EPIC/CRUD_GET_LIST_FAILURE';
export const CRUD_GET_LIST_SUCCESS = 'EPIC/CRUD_GET_LIST_SUCCESS';
export const CRUD_GET_LIST_CANCELLED = 'EPIC/CRUD_GET_LIST_CANCELLED';
